import React, { useEffect } from 'react';
import { Box, Grid } from '@material-ui/core';
import Modal from 'components/Modal';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { injectIntl } from 'react-intl';
import { SizedLongBody } from 'containers/SignupPages/PersonalInfo/styles';
import { translate } from 'helpers/intl';
import messages from 'containers/MRHDetailsPage/messages';
import { StyledShortBody } from 'containers/MRhDashboard/services/styles';
import { sanlamDarkGrayishBlue } from 'Material-UI/colors';
import {
  openModalServicesMrh,
  closeModalServicesMrh,
} from 'store/global/actions';
import { contactMrh } from 'utils/globalConst';
import { StyledBodyText } from 'components/ModalServices/ModalServicesAuto/styles';
import { OrangeButton } from 'components/Button';
import ChevronCardButton from 'components/ChevronCardButton';
import { sanlamVeryLightgray } from 'Material-UI/colors';
import { IntlShape } from 'react-intl';
import { getAgents } from 'store/geolocAgent/actions';
import {
  StyledGrid,
  StyledGridLeft,
} from 'components/ModalServices/ModalServicesAuto/styles';
import { getAgentSelector } from 'store/geolocAgent/selectors';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { reversedNum } from 'utils/string';
import { StyledLink } from 'containers/MRhDashboard/services/styles';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const ModalServicesMrh = ({
  openModalServicesMrh,
  closeModalServicesMrh,
  isOpen,
  agentInfo,
  ...props
}: {
  intl: IntlShape;
  openModalServicesMrh: Function;
  closeModalServicesMrh: Function;
  isOpen: Boolean;
  agentInfo: { FAX: string; AGT_EMAIL: string };
  getAgents: Function;
}) => {
  /* eslint-disable */
  useEffect(() => {
    getAgents();
  }, [getAgents]);
  /* eslint-enable */
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const items = [
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_ACCUEIL}
          label="Que faire en cas de sinistre ? 0522 480 480"
        >
          <StyledLink href={`tel:${contactMrh.serviceFr}`}>
            <Grid container direction="row">
              <Grid>
                <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
                  {translate(messages.contact_service_mrh, props)}
                </StyledShortBody>
              </Grid>
              <StyledGridLeft reverse={reverse}>
                <StyledShortBody color="#6D2C8F" weight="500">
                  {reverse ? contactMrh.serviceAr : contactMrh.serviceFr}
                </StyledShortBody>
              </StyledGridLeft>
            </Grid>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'CallService',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_ACCUEIL}
          label="Que faire en cas de sinistre ? Contacter mon agent par tel"
        >
          <StyledLink href={`tel:${agentInfo && agentInfo.FAX}`}>
            <Grid container direction="row">
              <Grid>
                <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
                  {translate(messages.agent_service_mrh, props)}
                </StyledShortBody>
              </Grid>
              <StyledGridLeft reverse={reverse} direction="rtl">
                <StyledShortBody color="#6D2C8F" weight="500">
                  {agentInfo && reverse
                    ? reversedNum(agentInfo.FAX)
                    : agentInfo && agentInfo.FAX}
                </StyledShortBody>
              </StyledGridLeft>
            </Grid>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'AgentCall',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.MRH_ACCUEIL}
          label="Que faire en cas de sinistre ? Contacter mon par email"
        >
          <Grid>
            <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
              {translate(messages.email_contact_mrh, props)}
            </StyledShortBody>
          </Grid>
        </GaClickHOC>
      ),
      icon: 'AgentEmail',
    },
  ];
  return (
    <>
      <Modal
        open={isOpen}
        handleOpen={openModalServicesMrh}
        handleClose={closeModalServicesMrh}
        header={
          <SizedLongBody weight="500" color="#04336B">
            {translate(messages.que_faire_en_cas_sinistre, props)}
          </SizedLongBody>
        }
        content={
          <>
            <Box paddingX={2}>
              <SizedLongBody weight="500" color="#04336B">
                {translate(messages.declarer_Sinistre_title, props)}
              </SizedLongBody>
              <StyledBodyText weight="300">
                {translate(messages.declarer_Sinistre_description, props)}
              </StyledBodyText>
              <Box marginTop={3} marginBottom={3}>
                {
                  /* istanbul ignore next */ agentInfo &&
                  isEmpty(agentInfo.FAX) ? (
                    <StyledGrid container spacing={3}>
                      {items
                        .filter((item: any) => item.icon !== 'AgentCallAuto')
                        .map((item: any, index: number) => (
                          <Grid item xs={12} key={index}>
                            <ChevronCardButton
                              borderColor={sanlamVeryLightgray}
                              item={item}
                              clickHandler={() =>
                                index === 2
                                  ? window.open(
                                      `mailto:${agentInfo.AGT_EMAIL}`,
                                      '_blank',
                                    )
                                  : null
                              }
                              deleteHoverBorder={true}
                            />
                          </Grid>
                        ))}
                    </StyledGrid>
                  ) : agentInfo && isEmpty(agentInfo.AGT_EMAIL) ? (
                    <StyledGrid container spacing={3}>
                      {items
                        .filter((item: any) => item.icon !== 'AgentEmailAuto')
                        .map((item: any, index: number) => (
                          <Grid item xs={12} key={index}>
                            <ChevronCardButton
                              borderColor={sanlamVeryLightgray}
                              item={item}
                              clickHandler={() =>
                                index === 2
                                  ? window.open(
                                      `mailto:${agentInfo.AGT_EMAIL}`,
                                      '_blank',
                                    )
                                  : null
                              }
                              deleteHoverBorder={true}
                            />
                          </Grid>
                        ))}
                    </StyledGrid>
                  ) : (
                    <StyledGrid container spacing={3}>
                      {items.map((item: any, index: number) => (
                        <Grid item xs={12} key={index}>
                          <ChevronCardButton
                            borderColor={sanlamVeryLightgray}
                            item={item}
                            clickHandler={() =>
                              index === 2
                                ? window.open(
                                    `mailto:${agentInfo.AGT_EMAIL}`,
                                    '_blank',
                                  )
                                : null
                            }
                            deleteHoverBorder={true}
                          />
                        </Grid>
                      ))}
                    </StyledGrid>
                  )
                }
              </Box>
            </Box>
          </>
        }
        footer={
          <Grid container justify="flex-end">
            <Grid item>
              <OrangeButton variant="contained" onClick={closeModalServicesMrh}>
                {translate(messages.close, props)}
              </OrangeButton>
            </Grid>
          </Grid>
        }
      ></Modal>
    </>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    agentInfo: { FAX: string; AGT_EMAIL: string };
  }
>({
  agentInfo: getAgentSelector,
});

const mapDispatchToProps = {
  closeModalServicesMrh,
  openModalServicesMrh,
  getAgents,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ModalServicesMrh));
